module.exports = __webpack_public_path__ + "img/NA.347a6e25.svg";